<template>
    <div v-if="firestoreContentLoaded" class="formation-single-wrapper">
        <header :class="firestoreContent.jsonHeader.backgroundType">
            <BGAssetLoader
                v-if="firestoreContent.jsonHeader.mainPhotoId !== 0"
                :asset="{ asset: firestoreContent.jsonHeader.mainPhotoId }"
                class="hero medium-overlap bg-img"
            />
            <div
                v-else
                :style="{
                    backgroundImage: `url(/static-assets/patterns/Pattern_${firestoreContent.jsonHeader.backgroundType}.svg)`,
                }"
                class="hero medium-overlap hero-graphic"
                :class="firestoreContent.jsonHeader.backgroundType"
            ></div>
        </header>

        <div class="page-content" page-transition-group>
            <article>
                <div class="container-xxl no-overflow-hidden padding-container-top">
                    <div class="row">
                        <div class="col-12 col-lg-7 col-xl-8 col-xxl-9">
                            <div class="row">
                                <div
                                    class="col-12 col-xxl-9 mb-5 pb-4 pb-md-0"
                                    :class="firestoreContent.jsonHeader.backgroundType"
                                >
                                    <p
                                        v-if="firestoreContent.formationType != null"
                                        class="formation-type-small"
                                    >
                                        {{ formationTypeTitle }}
                                    </p>
                                    <br />
                                    <h1
                                        v-if="firestoreContent.title != null"
                                        class="main-search-title font-size-h3 split-text move-left"
                                        v-html="splitText(firestoreContent.title)"
                                    ></h1>
                                </div>
                            </div>

                            <div
                                v-if="firestoreContent.jsonHeader.introductionPage != null"
                                class="row"
                            >
                                <div class="col-12 col-md-6 col-lg-12 col-xxl-9">
                                    <div class="formation-introduction">
                                        <h5
                                            class="main-search-descritpion"
                                            v-html="firestoreContent.jsonHeader.introductionPage"
                                        ></h5>
                                    </div>
                                </div>

                                <div
                                    class="col-12 col-md-6 col-lg-12 mb-5 pb-4 mb-md-0 pb-md-0 d-none d-md-block d-lg-none"
                                >
                                    <InformationInfosCard
                                        v-if="firestoreContentLoaded"
                                        :formationContent="firestoreContent"
                                        :ifSingleTemplate="true"
                                    />
                                </div>
                            </div>

                            <div class="row d-lg-none row-info-card-mobile">
                                <div class="d-md-none">
                                    <InformationInfosCard
                                        v-if="firestoreContentLoaded"
                                        :formationContent="firestoreContent"
                                        :ifSingleTemplate="true"
                                    />
                                </div>

                            </div>

                            <div id="profils-top" class="row padding-container">
                                <div
                                    v-if="firestoreContent.formationType == 'creation'"
                                    class="col-12 mb-3"
                                >
                                    <h6 class="text-uppercase">{{ $t('Profils') }}</h6>
                                </div>

                                <div class="col-12">
                                    <ul
                                        v-if="firestoreContent.formationType == 'creation'"
                                        class="nav nav-tabs d-flex"
                                        id="tabs-formation"
                                        role="tablist"
                                        @click="scrollToTabs"
                                    >
                                        <li
                                            v-for="(tab, index) in firestoreContent.jsonBody
                                                .profils"
                                            :key="'tab-formation-' + index"
                                            class="nav-item"
                                            :class="'order-' + tab.order"
                                        >
                                            <button
                                                class="nav-link font-size-h4"
                                                :class="tab.order == 1 ? 'active' : ''"
                                                :id="removeAccents(tab.profilName) + '-tab'"
                                                data-bs-toggle="tab"
                                                :data-bs-target="
                                                    '#' +
                                                    removeAccents(tab.profilName) +
                                                    '-tab-content'
                                                "
                                                type="button"
                                                role="tab"
                                                :aria-controls="
                                                    removeAccents(tab.profilName) + '-tab-content'
                                                "
                                                aria-selected="true"
                                            >
                                                {{ tab.profilName }}
                                            </button>
                                        </li>
                                    </ul>

                                    <div
                                        v-if="firestoreContent.formationType == 'creation'"
                                        class="tab-content"
                                        id="myTabContent"
                                    >
                                        <div
                                            v-for="(tab, index) in firestoreContent.jsonBody
                                                .profils"
                                            :key="'tab-content-formation-' + index"
                                            class="tab-pane fade"
                                            :class="tab.order == 1 ? 'show active' : ''"
                                            :id="removeAccents(tab.profilName) + '-tab-content'"
                                            role="tabpanel"
                                            :aria-labelledby="
                                                removeAccents(tab.profilName) + '-tab'
                                            "
                                            tabindex="0"
                                        >
                                            <FormationTabContent
                                                :tabContent="tab"
                                                :tabIndex="index"
                                                :formateursDefaultImg="globals.formationTabsTitleSections.formateursDefaultImage"
                                            />
                                        </div>
                                    </div>

                                    <template v-else>
                                        <div
                                            v-for="(tab, index) in firestoreContent.jsonBody
                                                .profils"
                                            :key="'content-formation-' + index"
                                            class=""
                                        >
                                            <FormationTabContent
                                                :tabContent="tab"
                                                :tabIndex="index"
                                                :formateurs="relatedFormateurs"
                                                :formateursDefaultImg="globals.formationTabsTitleSections.formateursDefaultImage"
                                            />
                                        </div>
                                    </template>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-5 col-xl-4 col-xxl-3 sticky-top-card align-self">
                            <InformationInfosCard
                                v-if="firestoreContentLoaded"
                                :formationContent="firestoreContent"
                                :ifSingleTemplate="true"
                                class=" d-none d-lg-block"
                            />
                            <SwiperPartners
                                v-if="firestoreContent.jsonHeader.partnerList && firestoreContent.jsonHeader.partnerList.length"
                                :imgGallery="firestoreContent.jsonHeader.partnerList"
                                :swiperId="'02'"
                                class="mt-4"
                            />
                        </div>
                    </div>
                </div>

                <div class="formation-formateurs">
                    <div class="container-xxl">
                        <div class="row">
                            <div class="col-12">
                                <div
                                    v-if="relatedFormateurs && relatedFormateurs.length > 0"
                                    class="padding-container margin-container-top"
                                >
                                    <h6 class="mb-5">{{ $t('Votre équipe de formation') }}</h6>
                                    <div class="row">
                                        <div
                                            v-for="(formateur, indexFormateur) in orderedFormateurs"
                                            :key="'formateur' + indexFormateur"
                                            class="col-12 col-md-6 col-lg-4 col-xl-3"
                                        >
                                            <router-link
                                                v-if="formateur.slug != null"
                                                :to="{
                                                    name: 'Membre-fr',
                                                    params: { slug: formateur.slug },
                                                }"
                                                class="formateur-card-link"
                                            >
                                                <FormateurCard :formateurData="formateur" :defaultImg="globals.formationTabsTitleSections.formateursDefaultImage" />
                                            </router-link>
                                            <div v-else class="formateur-card">
                                                <FormateurCard :formateurData="formateur" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="container-xxl">

                    <div
                        v-if="relatedContent && relatedContent.length > 0"
                        class="row"
                    >
                        <div class="col-12 mb-5"></div>
                        <div class="col-12 col-md-6">
                            <h6 class="mb-0 text-uppercase">{{ $t('Autres formations') }}</h6>
                        </div>

                        <div class="col-12 col-md-6 d-flex justify-content-end">
                            <router-link
                                :to="{ path: '/nos-formations' }"
                                class="bold text-red link-arrow right"
                                itemtype="https://www.schema.org/SiteNavigationElement"
                            >
                                {{ $t('Voir plus') }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div v-if="firestoreContentLoaded && relatedContent.length > 0" class="container-xxl padding-container-top overflow-container">
                    <div class="row padding-container-bottom">
                        <div class="col-12">
                            <SwiperRelatedFormations :relatedFormations="relatedContent" />
                        </div>
                    </div>
                </div>
            </article>

            <FormationCta
                v-if="globals.formationTabsTitleSections.formationsCta && contentIsLoaded"
            />
        </div>
    </div>
    <div class="page-wait-load-ph" v-else></div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters, mapActions } from 'vuex'
import { getDocBySlug, getSuggestionsData, getFormateursData } from '@/firebase/init'
// import { getAssetById } from '@/plugins/Helpers'

import InformationInfosCard from '@/components/Parts/InformationInfosCard'
import FormationTabContent from '@/components/Parts/FormationTabContent'
import FormationCta from '@/components/Parts/FormationCta'
import SwiperPartners from '@/components/swiper/SwiperPartners'
import SwiperRelatedFormations from '@/components/swiper/SwiperRelatedFormations'
import FormateurCard from '@/components/loopTemplate/FormateurCard'
import dayjs from 'dayjs'

// Import bootstrap tabs & accordions
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/collapse'

const utf8 = require('utf8')

// import AssetLoader from '@/components/helpers/AssetLoader'
import BGAssetLoader from '@/components/helpers/BGAssetLoader'

export default {
    name: 'Formation',

    metaInfo() {
        return {
            ...(this.firestoreContentLoaded && this.firestoreContent.jsonHeader.metaTitle && { title: this.firestoreContent.jsonHeader.metaTitle }),
            ...(this.firestoreContentLoaded && this.firestoreContent.jsonHeader.metaTitle &&  { titleTemplate: this.firestoreContent.jsonHeader.metaTitle }),

            meta: [
                {
                    vmid: 'og:title',
                    property: 'og:title',
                    content: this.firestoreContentLoaded ? this.firestoreContent.jsonHeader.metaTitle : '',
                },

                {
                    vmid: 'description',
                    name: 'description',
                    content: this.firestoreContentLoaded ? this.firestoreContent.jsonHeader.metaDescription : '',
                },
                {
                    vmid: 'og:description',
                    property: 'og:description',
                    content: this.firestoreContentLoaded ? this.firestoreContent.jsonHeader.metaDescription : '',
                },
                {
                    vmid: 'twitter:title',
                    name: 'twitter:title',
                    content: this.firestoreContentLoaded ? this.firestoreContent.jsonHeader.metaTitle : '',
                },
                {
                    vmid: 'twitter:description',
                    name: 'twitter:description',
                    content: this.firestoreContentLoaded ? this.firestoreContent.jsonHeader.metaDescription : '',
                },
            ],
        }
    },

    components: {
        // AssetLoader,
        BGAssetLoader,
        InformationInfosCard,
        SwiperPartners,
        FormationTabContent,
        FormationCta,
        SwiperRelatedFormations,
        FormateurCard
    },

    data() {
        return {
            firestoreContent: [],
            relatedContent: [],
            relatedFormateurs: [],
        }
    },

    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    let res = null

                    if (
                        this.$route.meta.firebaseCollection &&
                        this.$route.meta.firebaseDocumentBySlug &&
                        this.$route.params.slug
                    ) {
                        res = await getDocBySlug(
                            this.$route.meta.firebaseCollection,
                            this.$route.params.slug
                        )

                        if (!res || !res.length) {
                            this.$router.push({
                                name: 'p404',
                            })
                            return
                        }

                        this.firestoreContent = res[0]

                        try {
                            // Base64 Decode
                            this.firestoreContent.jsonBody = atob(this.firestoreContent.jsonBody)
                            // Utf8 Decode
                            this.firestoreContent.jsonBody = utf8.decode(
                                this.firestoreContent.jsonBody
                            )
                            // Json Parse
                            this.firestoreContent.jsonBody = JSON.parse(
                                this.firestoreContent.jsonBody
                            )

                            // Base64 Decode
                            this.firestoreContent.jsonHeader = atob(
                                this.firestoreContent.jsonHeader
                            )
                            // Utf8 Decode
                            this.firestoreContent.jsonHeader = utf8.decode(
                                this.firestoreContent.jsonHeader
                            )
                            // Json Parse
                            this.firestoreContent.jsonHeader = JSON.parse(
                                this.firestoreContent.jsonHeader
                            )

                            this.setFirestoreContentLoaded(true)
                            this.setBgTheme(this.firestoreContent.jsonHeader.backgroundType)
                            this.setFirestoreContentData(this.firestoreContent)

                            setTimeout(() => {
                                if (this.$route.hash) {
                                    const tab = `${ this.$route.hash }-tab-content`
                                    const tabDom = document.querySelector(`[data-bs-target="${tab}"]`);
                                    // console.log(tab, tabDom);
                                    // ScrollTo tab
                                    if (tabDom) {
                                        tabDom.click()
                                        setTimeout(() => {
                                            window.scrollTo({
                                                top: tabDom.offsetTop - 100,
                                                behavior: 'smooth',
                                            })
                                        }, 500)
                                    }
                                }
                            }, 1000)
                        } catch (e) {
                            this.setErrorsReportMsg(e)
                        }

                        // Fetch related content data for suggestions array
                        try {
                            // This may throw an error

                            this.relatedContent = await getSuggestionsData(
                                this.firestoreContent.jsonBody.suggestions,
                                this.firestoreContent.filterInterest,
                                this.firestoreContent.id,
                            )

                            this.relatedContent = this.relatedContent.sort((a, b) => {
                                return dayjs(a.startDate).diff(dayjs(b.startDate))
                            })
                        } catch (e) {
                            this.relatedContent = []
                        }

                        // Fetch related content data for formateurs array
                        try {
                            // This may throw an error
                            this.relatedFormateurs = await getFormateursData(
                                this.firestoreContent.jsonBody.formateurs
                            )
                        } catch (e) {
                            this.relatedFormateurs = []
                        }

                        return
                    }
                }
            },
            immediate: true,
        },
    },

    computed: {
        formationTypeTitle () {
            if (!this.firestoreContentLoaded) {
                return ''
            }
            const formationTypeSlug = this.firestoreContent.formationType
            return this.globals.categoriesFormations.find(formationType => formationType.slug === formationTypeSlug).title
        },
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        orderedFormateurs() {
            if(!this.relatedFormateurs) {
                return []
            }
            const formateursList = [...this.relatedFormateurs]
            return formateursList.sort((a, b) => {
                return a.original.order - b.original.order
            })
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals', 'firestoreContentLoaded']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg', 'setBgTheme', 'setFirestoreContentLoaded', 'setFirestoreContentData']),
        formatDate(actualDate) {
            return dayjs(actualDate, 'YYYY-MM-DD').format('D MMMM YYYY')
        },
        splitText(text) {
            var splitedText = ''
            const myArray = text.split(' ')
            myArray.forEach(function (el) {
                splitedText += '<span>' + el + '</span>'
            })
            return splitedText
        },
        removeAccents(text) {
            return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        },
        scrollToTabs() {
          const tabs = document.getElementById('profils-top')
          // console.log('element  >  ' + tabs.offsetTop)
          window.scrollTo(0, tabs.offsetTop);

        },
    },
}
</script>

<style lang="scss"></style>
